import { BsdsInput } from '@bsds-lib-component/react';
import React from 'react';

import { useMaskedBsdsInput } from '../../hooks/useMaskedBsdsInput';
import type { CpfInputProps } from '../../types';
import { cleanCpf, formatCpf, validateCpf } from '../../utils/cpfUtils';

const isCpfComplete = (cleaned: string) => cleaned.length === 11;
const cpfInvalidMessage = () => 'CPF inválido';

export const CpfInput: React.FC<CpfInputProps> = ({
  value,
  onChange,
  onValidationChange,
  placeholder = '000.000.000-00',
  required = false,
  disabled = false,
  className = '',
  label,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  'aria-required': ariaRequired,
  'aria-disabled': ariaDisabled,
  'aria-autocomplete': ariaAutocomplete,
  'aria-haspopup': ariaHasPopup,
  'aria-controls': ariaControls,
  'aria-owns': ariaOwns,
  'aria-activedescendant': ariaActiveDescendant,
  'aria-errormessage': ariaErrorMessage,
}) => {
  const { inputRef, errorMessage, safeValue, handleChange, handleInput } = useMaskedBsdsInput({
    value,
    onChange,
    onValidationChange,
    required,
    format: formatCpf,
    clean: cleanCpf,
    isComplete: isCpfComplete,
    validate: validateCpf,
    invalidMessage: cpfInvalidMessage,
    requiredMessage: 'CPF é obrigatório',
  });

  return (
    <BsdsInput
      ref={inputRef}
      value={safeValue}
      onChange={handleChange}
      onInput={handleInput}
      placeholder={placeholder}
      label={label}
      required={required}
      disabled={disabled}
      className={className}
      maxlength={14}
      type="text"
      clearInput={false}
      inputMode="numeric"
      errorText={errorMessage}
      hasHintIcon
      color="primary"
      platform="web"
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      aria-required={ariaRequired}
      aria-disabled={ariaDisabled}
      aria-autocomplete={ariaAutocomplete}
      aria-haspopup={ariaHasPopup}
      aria-controls={ariaControls}
      aria-owns={ariaOwns}
      aria-activedescendant={ariaActiveDescendant}
      aria-errormessage={ariaErrorMessage}
    />
  );
};
